import { difference, groupBy } from "lodash";
import { KeywordModalState } from "../../api/Blueprints";

export type StateListKeys =
  | "includeExact"
  | "includeFuzzy"
  | "excludeExact"
  | "excludeFuzzy";

function getStateListGroups(state: KeywordModalState) {
  let foundArrays = [];
  let key: keyof KeywordModalState;
  for (key in state) {
    if (Array.isArray(state[key])) {
      foundArrays.push(state[key]);
    }
  }
  const groupedDict = groupBy(foundArrays.flat());
  return groupedDict;
}

export function checkStateForDuplicates(state: KeywordModalState) {
  const groupedDict = getStateListGroups(state);

  return (
    Object.keys(groupedDict).filter((key) => groupedDict[key].length > 1)
      .length > 0
  );
}

export function removeNewListDuplicatesAcrossStateLists(
  newList: string[],
  state: KeywordModalState
) {
  const groupedDict = getStateListGroups(state);
  const existingWords = Object.keys(groupedDict);
  return difference(newList, existingWords);
}
